export default function UploadProgress({ percent, note }) {
  if (percent == null) return null;
  return (
    <div data-testid="upload-progress" className="mt-4">
      <div className="flex justify-between mb-2">
        <span className="overline-label !text-[10px]">{note || "Uploading"}</span>
        <span className="overline-label !text-[10px] !text-accent" data-testid="upload-progress-value">{percent}%</span>
      </div>
      <div className="h-[3px] bg-white/10 w-full">
        <div
          data-testid="upload-progress-bar"
          className="h-full bg-accent transition-[width] duration-200"
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
}
